import { RouterProvider } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import client from "@/services/http";
import { AuthProvider } from "@/contexts";
import router from "@/navigations/router";

function App() {
	return (
		<AuthProvider>
			<ApolloProvider client={client}>
				<RouterProvider router={router} />
			</ApolloProvider>
		</AuthProvider>
	);
}

export default App;
